var map = {
	"./bg-glow.svg": 60,
	"./bg-s-shape.svg": 61,
	"./svg-sprite/icon-email.svg": 62,
	"./svg-sprite/icon-linkedin.svg": 63,
	"./svg-sprite/icon-minus.svg": 64,
	"./svg-sprite/icon-paper-plane.svg": 65,
	"./svg-sprite/icon-plus.svg": 66,
	"./svg-sprite/icon-pointer-arrow.svg": 67,
	"./svg-sprite/icon-scroll-down.svg": 68
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 59;